import { ViewInterface } from './viewInterface.js';

const FIELD_LABELS = {
  any: '不限',
  fictional: '虚拟人物',
  science: '科学',
  art: '艺术',
  sports: '体育',
  politics: '政治',
  business: '商业',
  entertainment: '娱乐',
  literature: '文学',
  military: '军事',
  other: '其他',
};

const DIFFICULTY_LABELS = {
  easy: '简单',
  medium: '中等',
  hard: '困难',
};

const GAME_MODE_LABELS = {
  celebrity: '名人猜猜猜',
  detective: '海龟汤',
};

const ANSWER_LABELS = {
  yes: '是',
  no: '否',
  unknown: '不确定',
  irrelevant: '无关',
};

export class NormalView extends ViewInterface {
  constructor(container) {
    super(container);
    this.isLoading = false;
  }

  init() {
    this.cacheElements();
    this.bindEvents();
  }

  cacheElements() {
    this.els = {
      provider: document.getElementById('provider'),
      baseURL: document.getElementById('baseURL'),
      apiKey: document.getElementById('apiKey'),
      model: document.getElementById('model'),
      temperature: document.getElementById('temperature'),
      temperatureValue: document.getElementById('temperature-value'),
      difficulty: document.getElementById('difficulty'),
      field: document.getElementById('field'),
      gameMode: document.getElementById('game-mode'),
      stealthMode: document.getElementById('stealth-mode'),
      saveApiKey: document.getElementById('saveApiKey'),
      saveSettings: document.getElementById('save-settings'),
      testConnection: document.getElementById('test-connection'),
      settingsMessage: document.getElementById('settings-message'),

      settingsBtn: document.getElementById('settings-btn'),
      settingsModal: document.getElementById('settings-modal'),
      settingsModalBackdrop: document.getElementById('settings-modal-backdrop'),
      settingsModalClose: document.getElementById('settings-modal-close'),
      stealthTheme: document.getElementById('stealth-theme'),
      summaryProvider: document.getElementById('summary-provider'),
      summaryModel: document.getElementById('summary-model'),
      summaryDifficulty: document.getElementById('summary-difficulty'),
      summaryField: document.getElementById('summary-field'),
      summaryMode: document.getElementById('summary-mode'),

      subtitle: document.getElementById('subtitle'),
      score: document.getElementById('score'),
      bestScore: document.getElementById('best-score'),
      currentDifficulty: document.getElementById('current-difficulty'),
      questionCount: document.getElementById('question-count'),
      guessCount: document.getElementById('guess-count'),

      caseCard: document.getElementById('case-card'),
      caseDescription: document.getElementById('case-description'),

      gameStageMessage: document.getElementById('game-stage-message'),
      questionForm: document.getElementById('question-form'),
      questionInput: document.getElementById('question-input'),
      questionBtn: document.getElementById('question-btn'),
      guessForm: document.getElementById('guess-form'),
      guessInput: document.getElementById('guess-input'),
      guessBtn: document.getElementById('guess-btn'),
      newGameBtn: document.getElementById('new-game-btn'),
      giveUpBtn: document.getElementById('give-up-btn'),
      gameMessage: document.getElementById('game-message'),

      historyCard: document.getElementById('history-card'),
      historyList: document.getElementById('history-list'),
    };
  }

  bindEvents() {
    this.els.saveSettings.addEventListener('click', () => this.emit('saveSettings'));
    this.els.testConnection.addEventListener('click', () => this.emit('testConnection'));
    this.els.newGameBtn.addEventListener('click', () => this.emit('newGame'));
    this.els.giveUpBtn.addEventListener('click', () => this.emit('giveUp'));
    this.els.questionForm.addEventListener('submit', (e) => {
      e.preventDefault();
      this.emit('questionSubmit');
    });
    this.els.guessForm.addEventListener('submit', (e) => {
      e.preventDefault();
      this.emit('guessSubmit');
    });

    this.els.settingsBtn.addEventListener('click', () => this.openSettingsModal());
    this.els.settingsModalClose.addEventListener('click', () => this.closeSettingsModal());
    this.els.settingsModalBackdrop.addEventListener('click', () => this.closeSettingsModal());
    this.els.settingsModal.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') this.closeSettingsModal();
    });

    this.els.temperature.addEventListener('input', () => {
      this.els.temperatureValue.textContent = this.els.temperature.value;
    });

    this.els.provider.addEventListener('change', () => this.onProviderChange());
    this.els.difficulty.addEventListener('change', () => this.updateSettingsSummaryFromUI());
    this.els.field.addEventListener('change', () => this.updateSettingsSummaryFromUI());
    this.els.gameMode.addEventListener('change', () => this.updateSettingsSummaryFromUI());
    this.els.stealthMode.addEventListener('change', () => this.emit('stealthModeChange', this.els.stealthMode.value === 'true'));
    this.els.stealthTheme?.addEventListener('change', () => this.emit('stealthThemeChange', this.els.stealthTheme.value));
  }

  emit(eventName, data) {
    const cb = this.callbacks[eventName];
    if (cb) cb(data);
  }

  onProviderChange() {
    const provider = this.els.provider.value;
    if (provider === 'anthropic') {
      this.els.baseURL.value = 'https://api.anthropic.com';
      this.els.model.value = 'claude-3-5-sonnet-20241022';
    } else if (provider === 'qwen') {
      this.els.baseURL.value = 'https://dashscope.aliyuncs.com/compatible-mode/v1';
      this.els.model.value = 'qwen-plus';
    } else if (provider === 'deepseek') {
      this.els.baseURL.value = 'https://api.deepseek.com';
      this.els.model.value = 'deepseek-v4-flash';
    } else {
      this.els.baseURL.value = 'https://api.openai.com/v1';
      this.els.model.value = 'gpt-4.1-mini';
    }
    this.updateSettingsSummaryFromUI();
  }

  openSettingsModal() {
    this.els.settingsModal.hidden = false;
    this.els.settingsModalClose.focus();
  }

  closeSettingsModal() {
    this.els.settingsModal.hidden = true;
  }

  updateSettingsSummaryFromUI() {
    this.els.summaryProvider.textContent = this.els.provider.options[this.els.provider.selectedIndex].text;
    this.els.summaryModel.textContent = this.els.model.value || '-';
    this.els.summaryDifficulty.textContent = this.els.difficulty.options[this.els.difficulty.selectedIndex].text;
    this.els.summaryField.textContent = this.els.field.options[this.els.field.selectedIndex].text;
    this.els.summaryMode.textContent = this.els.gameMode.options[this.els.gameMode.selectedIndex].text;
  }

  getSettings() {
    return {
      provider: this.els.provider.value,
      baseURL: this.els.baseURL.value.trim(),
      apiKey: this.els.apiKey.value.trim(),
      model: this.els.model.value.trim(),
      temperature: parseFloat(this.els.temperature.value),
      difficulty: this.els.difficulty.value,
      field: this.els.field.value,
      gameMode: this.els.gameMode.value,
      saveApiKey: this.els.saveApiKey.checked,
      stealthMode: this.els.stealthMode.value === 'true',
      stealthTheme: this.els.stealthTheme?.value || 'dark',
    };
  }

  setSettings(config) {
    this.els.provider.value = config.provider;
    this.els.baseURL.value = config.baseURL;
    this.els.apiKey.value = config.apiKey;
    this.els.model.value = config.model;
    this.els.temperature.value = config.temperature;
    this.els.temperatureValue.textContent = config.temperature;
    this.els.difficulty.value = config.difficulty;
    this.els.field.value = config.field;
    this.els.gameMode.value = config.gameMode || 'celebrity';
    this.els.saveApiKey.checked = config.saveApiKey;
    this.els.stealthMode.value = config.stealthMode ? 'true' : 'false';
    if (this.els.stealthTheme) {
      this.els.stealthTheme.value = config.stealthTheme || 'dark';
    }
    this.updateSettingsSummaryFromUI();
  }

  updateSettingsSummary(config) {
    this.els.summaryProvider.textContent = this.els.provider.querySelector(`[value="${config.provider}"]`)?.textContent || config.provider;
    this.els.summaryModel.textContent = config.model || '-';
    this.els.summaryDifficulty.textContent = DIFFICULTY_LABELS[config.difficulty] || config.difficulty;
    this.els.summaryField.textContent = FIELD_LABELS[config.field] || config.field;
    this.els.summaryMode.textContent = GAME_MODE_LABELS[config.gameMode] || config.gameMode;
  }

  showSettingsMessage(message, type = 'info') {
    this.els.settingsMessage.textContent = message;
    this.els.settingsMessage.className = `message ${type}`;
    setTimeout(() => {
      this.els.settingsMessage.textContent = '';
      this.els.settingsMessage.className = 'message';
    }, 5000);
  }

  showGameMessage(message, type = 'info') {
    this.els.gameMessage.textContent = message;
    this.els.gameMessage.className = `message ${type}`;
  }

  clearGameMessage() {
    this.els.gameMessage.textContent = '';
    this.els.gameMessage.className = 'message';
  }

  getQuestionInput() {
    return this.els.questionInput.value.trim();
  }

  clearQuestionInput() {
    this.els.questionInput.value = '';
  }

  getGuessInput() {
    return this.els.guessInput.value.trim();
  }

  clearGuessInput() {
    this.els.guessInput.value = '';
  }

  render(state, config) {
    const isDetective = config.gameMode === 'detective';

    this.els.subtitle.textContent = isDetective
      ? '阅读汤面，通过是非提问还原汤底'
      : '通过是非提问，猜出这位名人';
    this.els.score.textContent = state.score;
    this.els.bestScore.textContent = state.bestScore;
    this.els.currentDifficulty.textContent = DIFFICULTY_LABELS[state.difficulty] || state.difficulty;
    this.els.questionCount.textContent = state.questionCount;
    this.els.guessCount.textContent = state.guessCount;

    this.updateInputPlaceholders(isDetective);
    this.els.guessBtn.textContent = isDetective ? '还原汤底' : '我猜是';

    if (!state.target) {
      this.els.gameStageMessage.textContent = '点击“新游戏”开始一局';
      this.els.gameStageMessage.hidden = false;
      this.els.historyCard.hidden = true;
      this.els.caseCard.hidden = true;
      this.setGameInputsEnabled(false);
      return;
    }

    this.els.gameStageMessage.hidden = true;
    this.els.historyCard.hidden = false;

    if (isDetective) {
      this.els.caseCard.hidden = false;
      this.els.caseDescription.textContent = state.target.description || '';
    } else {
      this.els.caseCard.hidden = true;
    }

    this.renderHistory(state, isDetective);
    this.renderStageMessage(state, isDetective);

    const canPlay = state.stage === 'playing';
    this.setGameInputsEnabled(canPlay);
    this.els.giveUpBtn.disabled = !state.target || this.isLoading;
  }

  updateInputPlaceholders(isDetective) {
    if (isDetective) {
      this.els.questionInput.placeholder = '输入一个是非题，例如：这件事和第三方有关吗？';
      this.els.guessInput.placeholder = '输入你对汤底的还原...';
      this.els.guessBtn.dataset.defaultLabel = '还原汤底';
    } else {
      this.els.questionInput.placeholder = '输入一个是非题，例如：是男性吗？';
      this.els.guessInput.placeholder = '输入名人名字，例如：爱因斯坦';
      this.els.guessBtn.dataset.defaultLabel = '我猜是';
    }
  }

  renderHistory(state, isDetective) {
    if (state.history.length === 0) {
      this.els.historyList.innerHTML = '<p class="empty-history">还没有问答记录</p>';
      return;
    }

    this.els.historyList.innerHTML = state.history
      .slice()
      .reverse()
      .map((h) => {
        if (h.type === 'question') {
          const answerLabel = ANSWER_LABELS[h.answer] || h.answer;
          return `
            <div class="history-item question">
              <div class="history-guess">问：${escapeHtml(h.input)}</div>
              <div class="history-feedback"><span class="answer-badge answer-${h.answer}">${answerLabel}</span> ${escapeHtml(h.feedback)}</div>
            </div>
          `;
        }

        const statusClass = h.correct ? 'correct' : 'wrong';
        let statusText;
        let actionLabel;
        if (isDetective) {
          actionLabel = '汤底还原';
          statusText = h.correct ? '✅ 汤底还原成功' : '❌ 汤底还原不准确';
        } else {
          actionLabel = '猜';
          statusText = h.correct ? '✅ 正确' : '❌ 错误';
        }
        return `
          <div class="history-item ${statusClass}">
            <div class="history-guess">${actionLabel}：${escapeHtml(h.input)} <span class="history-status">${statusText}</span></div>
            <div class="history-feedback">${escapeHtml(h.feedback)}</div>
          </div>
        `;
      })
      .join('');
  }

  renderStageMessage(state, isDetective) {
    if (state.stage === 'won') {
      const last = state.history[state.history.length - 1];
      const winText = isDetective ? '恭喜你还原了汤底！' : '恭喜你猜对了！';
      let message = `🎉 ${winText}${last?.feedback || ''}`;
      if (isDetective && state.target?.fullStory) {
        message += `\n\n汤底：${state.target.fullStory}`;
      }
      this.showGameMessage(message, 'success');
    } else if (state.stage === 'lost') {
      if (isDetective) {
        const answer = state.target?.fullStory ? `汤底是：${state.target.fullStory}` : '';
        this.showGameMessage(`😢 游戏结束。${answer}`, 'error');
      } else {
        const answer = state.target?.name ? `正确答案是：${state.target.name}` : '';
        this.showGameMessage(`😢 游戏结束。${answer}`, 'error');
      }
    } else {
      const lastGuess = [...state.history].reverse().find(h => h.type === 'guess');
      if (lastGuess) {
        this.showGameMessage(`❌ 不对，${lastGuess.feedback}`, 'info');
      } else {
        this.clearGameMessage();
      }
    }
  }

  setLoading(loading, state, config) {
    this.isLoading = loading;
    const canPlay = state?.stage === 'playing';
    const isDetective = config?.gameMode === 'detective';

    this.els.questionInput.disabled = loading || !canPlay;
    this.els.questionBtn.disabled = loading || !canPlay;
    this.els.guessInput.disabled = loading || !canPlay;
    this.els.guessBtn.disabled = loading || !canPlay;
    this.els.giveUpBtn.disabled = loading || !state?.target;
    this.els.newGameBtn.disabled = loading;

    if (loading) {
      this.els.questionBtn.textContent = '思考中...';
      this.els.guessBtn.textContent = '思考中...';
    } else {
      this.els.questionBtn.textContent = '提问';
      const defaultLabel = isDetective ? '还原汤底' : (this.els.guessBtn.dataset.defaultLabel || '我猜是');
      this.els.guessBtn.textContent = defaultLabel;
    }
  }

  setGameInputsEnabled(enabled) {
    this.els.questionInput.disabled = !enabled || this.isLoading;
    this.els.questionBtn.disabled = !enabled || this.isLoading;
    this.els.guessInput.disabled = !enabled || this.isLoading;
    this.els.guessBtn.disabled = !enabled || this.isLoading;
  }
}

function escapeHtml(text) {
  const div = document.createElement('div');
  div.textContent = text;
  return div.innerHTML;
}
